import React, { Fragment } from 'react';

import gridsBehaviourList from '../constants/gridsBehaviourList';
import styles from './GridsUsage.css';

const getImagePath = image => require(`@assets/images/grids-behaviour/${image}.png`);

const TextStylesUsage = () => (
  <Fragment>
    <section className={styles.topSection}>
      <article className="flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            A set of rules and techniques were calculated to ensure the fluidity that the site would need to fit into any screen size.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Having in mind scalability, flexibility and unified experience across every product from Airtel portfolio, a set of rules were calculated to ensure the fluidity that the site would need to fit into any container or screen size.</p>
          <p>Major breakpoints were defined into media queries that will mark the transition between resolutions or between devices. These breakpoints are set based on analytics of the most used resolutions in the world.</p>
          <p>Today screen ratios are most common in wide formats, so the grids structure are created to make use of that proportion, highlighting the use of vertical panels that use the full height of the viewports, distributing at the same time the horizontal page to provide in most cases a sense of continuity when the user experiences the interface.</p>
          <p>Remaining elements, components or even compositions are all built with this rules in mind to seamlessly, have every part of the platform work in a unified visual experience that spreads itself across any product, screen or device.</p>
        </div>
      </article>
    </section>

    <section className="with-padding bg-grey last">
      <article>
        <h2 className="h2 page-subtitle">Grid Behaviour</h2>
        <h3 className="large">Using Full Width Container as an example</h3>
        {
          gridsBehaviourList.map((grid, i) => (
            <div className={styles.grid} key={`grid-${i}`}>
              <img src={getImagePath(grid.image)} alt="grid image exemple"/>
              <p>{grid.media}</p>
              <p>{grid.columns}</p>
            </div>
          ))
        }
      </article>

    </section>
  </Fragment>
);

export default TextStylesUsage;



// WEBPACK FOOTER //
// ./src/containers/foundations/Grids/GridsUsage/GridsUsage.js